import getDocument from './getDocument';
import getWindow from './getWindow';
import isLocalEnv from './isLocalEnv';
import { queryRawLocalStorage } from './localstorage';
export function isSeleniumRunning() {
  return getDocument().cookie.includes('hs_selenium');
}
export function isJasmineRunning() {
  const _window = getWindow();
  return _window && 'jasmineRequire' in _window;
}
export function isLocalWithoutSentryOverride() {
  try {
    return isLocalEnv() && queryRawLocalStorage('ENABLE_SENTRY') !== 'true';
  } catch (_unused) {
    // noop
  }
  return false;
}